{
  "notifications": {
    "waitlistedUpgradeEcoTo": {
      "ECOPREMIUM": {
        "moreThan48HoursToDeparture": {
          "text": "Premium economy -luokan korotuksesi on jonotuslistalla lennolle {origin}–{destination}. Saat päivityksen tilanteesta sähköpostitse viimeistään 48 tuntia ennen lähtöä."
        }
      },
      "BUSINESS": {
        "moreThan48HoursToDeparture": {
          "text": "Businessluokan korotuksesi on jonotuslistalla lennolle {origin}–{destination}. Saat päivityksen tilanteesta sähköpostitse viimeistään 48 tuntia ennen lähtöä."
        }
      }
    }
  }
}
